<div>
  <button style="float: right;" title="Salva" (click)="closeDialog()" mat-icon-button color="warn" aria-label="icon-button save">
    <mat-icon>close</mat-icon>
  </button>
</div>
<h1 style="text-align: center">Anteprima profilo:</h1>
<div style="text-align: left;">
    <mat-selection-list #doc [multiple]="false">
        <ng-container *ngFor="let data of this.ELEMENT_DATA">
            <ng-container *ngIf="data.fields != ''">
                <mat-accordion>
                    <mat-expansion-panel (opened)="panelOpenState = true"
                                         (closed)="panelOpenState = false">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div style="width:100%;">
                                    <b><!--{{data.labelGroup}}, -->{{data.label}}</b>
                                </div>
                            </mat-panel-title>
                            <mat-panel-description>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <ng-container *ngFor="let campo of data.fields">
                            <ng-container *ngIf="campo.value">
                                <ng-container *ngIf="campo.value != '[object Object]'"><b>{{campo.description}}: </b>
                                    <p>{{campo.value}}</p></ng-container>
                                <ng-container *ngIf="campo.value == '[object Object]'"><b>{{campo.description}}: </b>
                                    <ng-container *ngIf="campo.value.name"><p>{{campo.value.name}}</p></ng-container>
                                    <ng-container *ngIf="!campo.value.name">
                                        <ng-container *ngIf="campo.value.description"><p>{{campo.value.description}}</p>
                                        </ng-container>
                                        <ng-container *ngIf="!campo.value.description">
                                            <ng-container *ngFor="let value of campo.value"><p>{{value.description}}</p>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>


                            </ng-container>
                        </ng-container>
                    </mat-expansion-panel>
                </mat-accordion>
            </ng-container>
        </ng-container>
    </mat-selection-list>
</div>

<!-- Copyright 2020 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->
